// extracted by mini-css-extract-plugin
export default {"simpleInput":"style_simpleInput__bF46M"};